module.exports = __webpack_public_path__ + "img/bird_1.f7f8f26f.png";